import { SearchCriteria } from '@/store/types/search-criteria';

export enum ContactFormSubmitStatus {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED',
  LISTING_OFFLINE = 'LISTING_OFFLINE',
  ERROR = 'ERROR',
  BLOCKED = 'BLOCKED',
}

export enum OwnerChecked {
  checked = 'checked',
  notChecked = 'not_checked',
  default = '',
}

export interface ContactFormData {
  language?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  message?: string;
  street?: string;
  zip?: string;
  city?: string;
  monthlyIncome?: string;
  employmentStatus?: string;
  equityCapital?: number;
  searchAlertName?: string;
  searchAlertCriteria?: SearchCriteria;
  owner: OwnerChecked;
  recaptchaToken?: string;
}

export interface ContactRequestResponse {
  contactRequest: {
    id: string;
  };
  emailVerification?: {
    required?: boolean;
  };
}
